import type { IconSvgObject } from './types';

const Minimize01Icon: IconSvgObject = [
  ["path", { d: "M20.0172 22V20C21.6 17.113 23.0974 13.8324 20.8804 11.9954C19.0758 10.5 16.0583 10 16.0583 10L16.7826 5.14282C17.0639 4.01174 16.2469 3 15.1324 3C14.3462 3 13.659 3.52825 13.4606 4.2853L11.5321 14.5L8.88321 12.239C8.1255 11.6039 7.04079 11.6394 6.37487 12.4044C5.88834 13.0425 5.86189 13.8134 6.37495 14.4824L11.0292 20.0089V22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 10L4.5 7.5M2 7H5V10M10 2L7.5 4.5M7 2L7.00141 5.00037L10 5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Minimize01Icon;
